import { Button, Textarea } from "@material-tailwind/react";
import Link from "next/link";
import { useState } from "react";

export interface ArticleCommentsTextInputProps {
  disabled?: boolean;
  onSubmit: (text: string) => Promise<boolean>;
}

const ArticleCommentsTextInput = ({
  disabled = false,
  onSubmit,
}: ArticleCommentsTextInputProps) => {
  const [content, setContent] = useState("");

  const handleSubmit = async () => {
    const resp = await onSubmit(content);
    if (resp) {
      setContent("");
    }
  };

  return (
    <form className="mb-6 flex flex-col">
      <div className="bg-white  ">
        <label className="sr-only">Your comment</label>
        <Textarea
          id="comment"
          rows={3}
          className="px-0 w-full rounded-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700 rounded-t-lg text-sm text-gray-900 border-0 focus:ring-0 focus:outline-none dark:text-white dark:placeholder-gray-400 dark:bg-gray-800"
          placeholder="Write a comment..."
          value={content}
          onChange={(e) => setContent(e.currentTarget.value)}
          disabled={disabled}
        />
      </div>
      {disabled && (
        <Link href={"/login"} as="a" className="my-2">
          <span className="underline">Login</span> to post a comment
        </Link>
      )}
      <div>
        <Button
          onClick={handleSubmit}
          disabled={disabled || content === ""}
          className="w-auto"
        >
          Post comment
        </Button>
      </div>
    </form>
  );
};
export default ArticleCommentsTextInput;
